import { STATUS_OPTIONS, DealerSearchInputProps } from "./types";
import { StatusDropdown } from "./StatusDropdown";

export function DealerSearchInput({
    searchTerm,
    onSearchChange,
    statusFilter,
    onStatusChange,
    isExpanded,
    visibleDealers,
    highlightIndex,
    onHighlightChange,
    onSelect,
}: DealerSearchInputProps) {
    return (
        <div className="flex gap-4 items-start w-full">
            <div className="flex flex-col gap-2.5 items-start py-2 min-w-[50px]">
                <div className="flex items-start w-full">
                    <p className="font-inter font-medium text-menu-hover text-sm whitespace-nowrap">Dealer</p>
                </div>
            </div>

            {/* Dealer Input with Status */}
            <div className="flex-1 rounded-[4px] relative">
                <div aria-hidden="true" className="absolute border border-[#e0e0e0] inset-0 pointer-events-none rounded-[4px]" />
                <div className="flex flex-row items-center h-full">
                    <div className="flex gap-[10px] items-center p-[10px] w-full">
                        {/* Search Input */}
                        <div className="flex gap-[10px] flex-1 items-center">
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={(e) => {
                                    onSearchChange(e.target.value);
                                    onHighlightChange(-1);
                                }}
                                placeholder="Search dealer name..."
                                className="font-inter border-none font-normal flex-1 text-title-color text-[14px] tracking-[-0.154px] outline-none bg-transparent placeholder:text-[#a0a2a7] w-full"
                                autoFocus
                                role="combobox"
                                aria-expanded={isExpanded}
                                aria-controls="dealer-listbox"
                                aria-autocomplete="list"
                                onKeyDown={(e) => {
                                    if (!visibleDealers.length) return;
                                    if (e.key === "ArrowDown") {
                                        e.preventDefault();
                                        onHighlightChange(Math.min(highlightIndex + 1, visibleDealers.length - 1));
                                    } else if (e.key === "ArrowUp") {
                                        e.preventDefault();
                                        onHighlightChange(Math.max(highlightIndex - 1, 0));
                                    } else if (e.key === "Enter") {
                                        if (highlightIndex >= 0 && highlightIndex < visibleDealers.length) {
                                            onSelect(visibleDealers[highlightIndex]);
                                        } else if (visibleDealers.length === 1) {
                                            onSelect(visibleDealers[0]);
                                        }
                                    }
                                }}
                            />
                        </div>

                        {/* Vertical Separator */}
                        <div className="h-[23px] w-px bg-[#F5F5F5] shrink-0" />

                        {/* Status Filter */}
                        <div className="flex gap-2 items-center p-1 rounded-[2px]">
                            <p className="font-inter font-normal text-menu-hover text-sm whitespace-nowrap">Status:</p>
                            <StatusDropdown values={statusFilter} options={STATUS_OPTIONS} onChange={onStatusChange} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
